import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import '../css/admin.lite.scss'
import {
    updateLastViewed,
    getPatientMessages,
    setPatientAndMsg,
    setSingleMsg
} from '../../store/action/actioncases.action'
import moment from 'moment'
import util from '../../util/util'
import { isEmpty,} from 'lodash'
import { constants } from '../../constants'

import { useHistory, useLocation } from 'react-router-dom'
import useNotification from '../../hooks/notification'
import { NOTIFICATION_SUBSCRIPTION ,ADD_NEW_COMMENT} from '../../services/graphql-subscription/notification/tags'


const LiteNotification = (props) => {
      var location = useLocation()
      let isAdminLite=location?.search==constants.ADMIN_LITE;
    useEffect(() => {
        if (isAdminLite) {
            const handleMessage = (message) => {
                const nativeRoute = message?.data?.route;
                if (nativeRoute == '/refreshNots') {
                    fetchMessages(true);
                }
            };

            window.addEventListener('message', handleMessage);
            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }

    }, [props.patientAndMsg, props.singleMsg]);
    let msgParams = { customerId: props.customer?._id }
    if (props.user?.surgeon) {
        msgParams.surgeonId = props.user.surgeon;
    }

    const params = msgParams;
    const notification = useNotification({
        gqltag: NOTIFICATION_SUBSCRIPTION,
        params: params,
    })

    const adminComments = useNotification({
        gqltag: ADD_NEW_COMMENT,
        params: params,
    })
    useEffect(() => {
        if (!isEmpty(notification.notification)) {
            const { onComment } = notification.notification
            if (onComment && onComment?.status) {
                fetchMessages(true)

            }
        }

        return () => {
            if (notification.notification.unsubscribe) notification.unsubscribe()
        }
    }, [notification.notification])

    //when admin send msg
    useEffect(() => {
        if (!isEmpty(adminComments.notification)) {
            const { addAdminCommentToLite } = adminComments.notification
            if (addAdminCommentToLite && addAdminCommentToLite?.status) {
                fetchMessages(true)
            }
        }
        return () => {
            if (adminComments.notification.unsubscribe) adminComments.unsubscribe()
        }
    }, [adminComments.notification])
    const fetchMessages = async (isnotification) => {
        try {
            const filter = {
                customerIds: props?.customer?._id
                    ? [props.customer._id]
                    : [props?.decoded?.customer],
            }

            if (props.user?.role === constants.ROLE.SURGEON || props.user?.surgeon) {
                filter.surgeonId = props.user?.surgeon
            }

            const data = await props.getPatientMessages({
                filters: filter,
                sorter: { field: 'lastUpdated', order: 'descend' },
            })

            if (isnotification) {
                if (isEmpty(props.patientAndMsg)) return data;
                const singlePatientAndMessage = data.find(
                    (m) => m?.patient?._id == props.patientAndMsg?.patient?._id
                )
                console.log(singlePatientAndMessage, "singlePatientAndMessage")

                props.setPatientAndMsg(singlePatientAndMessage)

                if (location.pathname == '/message-interface') {
                    const single = singlePatientAndMessage?.messages.find(
                        (msg) => msg._id == props.singleMsg?.message?.caseId
                    )
                    props.setSingleMsg({ ...props.singleMsg, message: single })
                    await props.updateLastViewed({ caseId: single?.caseId })
                    await fetchMessages()
                }
            }
            return data
        } catch (err) {
            console.log(err, 'Error')
        }
    }

    return (<></>)
}

const mapStateToProps = (state) => {
    return {
        token: util.verifyToken(state.profile.token),
        company: state.profile.company,
        patientLoading: state.patient.isLoading,
        customer: state.profile.customer,
        singleMsg: state.actioncase.singleMsg,
        patientAndMsg: state.actioncase.patientAndMsg,
        user: state.profile.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getPatientMessages: (params) => dispatch(getPatientMessages(params)),
        setPatientAndMsg: (params) => dispatch(setPatientAndMsg(params)),
        setSingleMsg: (params) => dispatch(setSingleMsg(params)),
        updateLastViewed: (params) => dispatch(updateLastViewed(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LiteNotification)
